// Opens the provider sign-in popup. The popup ends on /api/v1/auth/social/exchange, which posts
// { access_token, invitationToken } on the "auth" BroadcastChannel; `callback` receives that event.
//
// `onPopupClosed` (optional) runs when the popup is gone, so a form can drop its loading state
// when the visitor closes the popup without signing in. Note: after the popup navigates to the
// provider, the browser can report it as closed early (Cross-Origin-Opener-Policy). Use this only
// to re-enable buttons, never to stop listening for the token.
export const socialLoginFactory =
  (callback, onPopupClosed = null) =>
  (provider, invitationToken = null, signupCode = null) => {
    let url = `/api/v1/auth/social/signin?provider=${encodeURIComponent(provider)}`;
    if (invitationToken) url += `&invitationToken=${encodeURIComponent(invitationToken)}`;
    if (signupCode) url += `&signupCode=${encodeURIComponent(signupCode)}`;
    openWindow(callback, onPopupClosed, url);
  };

function openWindow(callback, onPopupClosed, url) {
  const width = 450;
  const height = 730;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;
  const bc = new BroadcastChannel("auth");
  bc.onmessage = (event) => {
    // One sign-in per popup. Closing the channel stops a second click from
    // delivering the token twice.
    bc.close();
    callback(event);
  };
  const popup = window.open(
    url,
    "_blank",
    `popup,menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=${width}, height=${height}, top=${top}, left=${left}`
  );

  if (!onPopupClosed) return;
  if (!popup) {
    // Popup blocked: nothing will ever post a token.
    bc.close();
    onPopupClosed();
    return;
  }
  const timer = setInterval(() => {
    if (popup.closed) {
      clearInterval(timer);
      onPopupClosed();
    }
  }, 500);
}
